import React, { useEffect, useState } from 'react';
import Sidebar from '../Components/Layout/Sidebar';
import { Header } from '../Components/Layout/Header';
import { supabase } from '../supabase';
import './SiteContent.css';
import PageTitle from '../Components/Common/PageTitle';
import Btn from '../Components/Common/Btn';

const SiteContent = () => {
    const [content, setContent] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchContent();
    }, []);

    const fetchContent = async () => {
        const { data, error } = await supabase
            .from('siteContent')
            .select('*')
            .eq('page_name', 'landing');

        if (!error && data) {
            const contentMap = data.reduce((acc, item) => {
                acc[item.content_key] = item;
                return acc;
            }, {});
            setContent(contentMap);
        }
        setLoading(false);
    };

    const handleUpdate = async (id, newValue) => {
        if (!id) return;
        await supabase.from('siteContent').update({ content_value: newValue }).eq('id', id);
    };

    if (loading) return <div className="loading">Initializing Dashboard...</div>;

    return (
        <main className='SiteContent'>
            <Sidebar />

            <div className='MainContent'>
                <Header />

                <div className='PageCards'>
                    <PageTitle TitleText='Site Content Management' SubText='Modify the visual and textual landscape of the Electrify Egypt 2024 digital portal. Updates reflect in real-time across the platform.' HeaderBtnsClass='NoHeaderBtns'/>

                    <div className='SectionEditors'>

                        {/* hero editor */}

                        <div className="EditorCard HeroEditor">
                            <div className="CardHeader">
                                <div className="IconContainer">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#56FF50" strokeWidth="2">
                                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                                    </svg>
                                </div>
                                <h3>Hero Section Editor</h3>
                            </div>

                            <div className="FieldGroup">
                                <label>SECTION LABEL</label>
                                <input 
                                    type="text"
                                    defaultValue={content.hero_label?.content_value} 
                                    onBlur={(e) => handleUpdate(content.hero_label?.id, e.target.value)}
                                />
                            </div>

                            <div className="FieldGroup">
                                <label>MAIN HERO HEADLINE</label>
                                <input 
                                    type="text"
                                    defaultValue={content.hero_title?.content_value} 
                                    onBlur={(e) => handleUpdate(content.hero_title?.id, e.target.value)}
                                />
                            </div>

                            <div className="FieldGroup">
                                <label>SUBHEADLINE & NARRATIVE</label>
                                <textarea 
                                    defaultValue={content.hero_subtitle?.content_value} 
                                    onBlur={(e) => handleUpdate(content.hero_subtitle?.id, e.target.value)}
                                />
                            </div>
                        </div>

                        {/* About editor */}

                        <div className="EditorCard AboutEditor">
                            <div className="CardHeader">
                                <div className="IconContainer">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#56FF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <line x1="12" y1="16" x2="12" y2="12"></line>
                                        <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                    </svg>
                                </div>
                                <h3>About Section Editor</h3>
                            </div>

                            <div className="FieldGroup">
                                <label>SECTION LABEL</label>
                                <input 
                                    type="text"
                                    placeholder="e.g. ABOUT / 02"
                                    defaultValue={content.about_label?.content_value} 
                                    onBlur={(e) => handleUpdate(content.about_label?.id, e.target.value)}
                                />
                            </div>

                            <div className="FieldGroup">
                                <label>ABOUT SECTION TITLE</label>
                                <input 
                                    type="text"
                                    placeholder="e.g. Why This Exhibition?"
                                    defaultValue={content.about_title?.content_value} 
                                    onBlur={(e) => handleUpdate(content.about_title?.id, e.target.value)}
                                />
                            </div>

                            <div className="FieldGroup">
                                <label>ABOUT DESCRIPTION & NARRATIVE</label>
                                <textarea 
                                    placeholder="Describe the mission and details of the event..."
                                    defaultValue={content.about_description?.content_value} 
                                    onBlur={(e) => handleUpdate(content.about_description?.id, e.target.value)}
                                />
                            </div>
                        </div>

                        {/* showroom editor */}

                        <div className="EditorCard ShowroomEditor">
                            <div className="CardHeader">
                                <div className="IconContainer">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#56FF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"></path>
                                        <circle cx="7" cy="17" r="2"></circle>
                                        <path d="M9 17h6"></path>
                                        <circle cx="17" cy="17" r="2"></circle>
                                    </svg>
                                </div>
                                <h3>Showroom Section Editor</h3>
                            </div>

                            <div className="FieldGroup">
                                <label>SECTION LABEL</label>
                                <input 
                                    type="text"
                                    placeholder="e.g. FEATURED / 04"
                                    defaultValue={content.showroom_label?.content_value} 
                                    onBlur={(e) => handleUpdate(content.showroom_label?.id, e.target.value)}
                                />
                            </div>

                            <div className="FieldGroup">
                                <label>SECTION TITLE</label>
                                <input 
                                    type="text"
                                    placeholder="e.g. Showroom"
                                    defaultValue={content.showroom_title?.content_value} 
                                    onBlur={(e) => handleUpdate(content.showroom_title?.id, e.target.value)}
                                />
                            </div>

                            <div className="RedirectContainer">
                                <div className="RedirectText">
                                    <p>Vehicle Fleet Management</p>
                                    <span>To edit car specifications (HP, Range, Speed) or swap featured models, visit the Vehicles page.</span>
                                </div>
                                <Btn 
                                    BtnText="Manage Fleet" 
                                    BtnStyle="GreenBtn" 
                                    BtnPath="/vehicles" 
                                />
                            </div>
                        </div>

                        {/* Experience Screens Section */}
                        <div className="ExperienceSectionWrapper">
                            <div className="SectionHeaderLabel">
                                <h2>Experience Screen Editors</h2>
                                <p>Modify titles, descriptions, and background images for the 4 interactive landing page screens.</p>
                            </div>

                            <div className="ExperienceGridContainer">
                                {[1, 2, 3, 4].map((num) => (
                                    <div key={num} className="EditorCard PromoCard">
                                        <div className="CardHeader">
                                            <div className="IconContainer">
                                                <span className="ScreenNumber">0{num}</span>
                                            </div>
                                            <h3>Screen 0{num} Editor</h3>
                                        </div>

                                        {/* Image URL Field */}
                                        <div className="FieldGroup">
                                            <label>BACKGROUND IMAGE URL</label>
                                            <input 
                                                type="text"
                                                placeholder="Paste image URL..."
                                                defaultValue={content[`exp_img${num}`]?.content_value} 
                                                onBlur={(e) => handleUpdate(content[`exp_img${num}`]?.id, e.target.value)}
                                            />
                                            {content[`exp_img${num}`]?.content_value && (
                                                <div className="DashboardImagePreview">
                                                    <img src={content[`exp_img${num}`]?.content_value} alt={`Preview 0${num}`} />
                                                </div>
                                            )}
                                        </div>

                                        {/* Title Field */}
                                        <div className="FieldGroup">
                                            <label>SCREEN TITLE</label>
                                            <input 
                                                type="text"
                                                placeholder="e.g. The Performance"
                                                defaultValue={content[`exp_screen${num}_title`]?.content_value} 
                                                onBlur={(e) => handleUpdate(content[`exp_screen${num}_title`]?.id, e.target.value)}
                                            />
                                        </div>

                                        {/* Subtitle/Description Field */}
                                        <div className="FieldGroup">
                                            <label>SCREEN DESCRIPTION</label>
                                            <textarea 
                                                className="PromoTextArea"
                                                placeholder="Short descriptive block..."
                                                defaultValue={content[`exp_screen${num}_sub`]?.content_value} 
                                                onBlur={(e) => handleUpdate(content[`exp_screen${num}_sub`]?.id, e.target.value)}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </main>
    );
};

export default SiteContent;